import React, { useState, useRef } from "react";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import swal from "sweetalert";
import * as api from "../../../actions/api";
import OrderFormData from "./OrderFormData.js";
import { useTranslation } from "react-i18next";

import { format } from 'date-fns';
const EditOrder = (props) => {
  const FacilityId = localStorage.getItem("FacilityId");
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const menukey = "order";
  const lan = localStorage.getItem("LangCode");

  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    OrderDate: "",
    OrderNo: "",
    OrderingFrom: "",
    OrderTypeId: "",
    ManyJsonSave: "",
    FacilityId: FacilityId,
    OrderBy: "",
    InternalApprover: "",
    ItemGroupId: "",
  });

  const [selectedDate, setSelectedDate] = useState(
    // new Date()
    format(new Date(), 'yyyy-MM-dd')
  );

  const [bCompleted, setbCompleted] = useState("-1");
  const [ManyTableData, setManyTableData] = useState([]);
  const [OrderId, setOrderId] = useState("0");
  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState("");
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [bFirst, setBFirst] = useState(true);

  const saveInFlightRef = useRef(false);

  const handleDataTableChange = (e) => {};

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const handleRDateChange = (date, field) => {
    let newDate;
    if (date == null) {
      newDate = date;
    } else {
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const { data } = useQuery(
    ["order", id],
    () =>
      api.getOrderInv(id).then((res) => {
        //This is for user has VIEW/EDIT permission in this page start
        if (props.permissionType === 1) {
          //when permissionType then it is only VIEW permission otherwise normal permission
          res.data.bCompleted = 1;
        }
        //This is for user has VIEW/EDIT permission in this page end

        setOrderId(id);
        setFormData(res.data);
        setbCompleted(res.data.bCompleted);
        setManyTableData(res.data.ManyJsonSave); //res.data.ManyJsonSave
        setUpdatedDetailGridData(res.data.ManyJsonSave);
        setGeneratedInvoiceNo(res.data.OrderNo);
        setBFirst(true);
        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );

  const { isLoading: isUpdateMutating, mutate: mutateUpdate } =
    useMutation(api.updateOrderInv, {
    onSuccess: (data) => {
      if (data.data.status == 404) {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      } else {
        if (data.status == 200) {
          if (data.data.IsCompleted == 0) {
            //console.log("Is commmmmmmmmm",OrderId);
            mutatePost(OrderId);
          } else {
            let route = `${data.data.data.OrderId}`;
            setbCompleted(data.data.data.bCompleted);
            setManyTableData(data.data.data.ManyJsonSave);
            props.history.push(route);

            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });

            //swal("Success!", "", "success");
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
      }
    },
  });

  const { isLoading: isPostMutating, mutate: mutatePost } = useMutation(
    api.postOrderInv,
    {
    onSuccess: (data) => {
      if (data.status == 200) {
        let route = `${OrderId}`;
        setbCompleted(data.data.data.bCompleted);
        setManyTableData(data.data.data.ManyJsonSave);

        props.history.push(route);

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });

        //swal("Success!", "", "success");
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  const isSubmitting = isUpdateMutating || isPostMutating;

  const runOrderUpdate = (payload) => {
    if (saveInFlightRef.current || isPostMutating) return;
    saveInFlightRef.current = true;
    mutateUpdate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const setUpdatedDetailsGridDataHandler = (rows) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = { ...formData, ManyJsonSave: rows };
      runOrderUpdate(fDtat);
    }
    setManyTableData(rows);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;
    setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleReset = () => {
    setFormData({
      OrderDate: "",
      OrderNo: "",
      ItemGroupId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = [
      "OrderDate",
      "OrderNo",
      "OrderingFrom",
      "OrderTypeId",
      "OrderBy",
    ];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = "field is Required !";
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    let ValidationCount = onDataValidation(ManyTableData);
    if (ValidationCount > 0) {
      props.openNoticeModal({
        isOpen: true,
        msg: DispensingLanguage[lan][menukey][
          "Please, mention reason of actual order quantity change"
        ],
        msgtype: 0,
        duration: 10000,
      });
      return;
    }

    if (validateForm(formData)) {
      let FinalData = { ...formData, ManyJsonSave: ManyTableData };
      runOrderUpdate(FinalData);
    }
  };

  const handlePost = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    let ValidationCount = onDataValidation(ManyTableData);
    if (ValidationCount > 0) {
      props.openNoticeModal({
        isOpen: true,
        msg: DispensingLanguage[lan][menukey][
          "Please, mention reason of actual order quantity change"
        ],
        msgtype: 0,
        duration: 10000,
      });
      return;
    }

    if (validateForm(formData)) {
      let FinalData = {
        ...formData,
        ManyJsonSave: ManyTableData,
        IsCompleted: 0,
      };

      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "Do you really want to complete this order stock?"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          if (saveInFlightRef.current || isSubmitting) return;
          runOrderUpdate(FinalData);
          /*
      swal(
        t(
          DispensingLanguage[lan][menukey][
            "Proof! Data Updated Successfully"
          ]
        ),
        {
          icon: "success",
        }
      );
      */
        }
      });
    }
  };

  const onDataValidation = (data) => {
    let ValidationCount = 0;

    for (let i = 0; i < data.length; i++) {
      let CalcOrderQty = data[i].CalcOrderQty;
      let ActualOrderQty = data[i].ActualOrderQty;
      let Remarks = data[i].Remarks;
     
     

      if (
        (CalcOrderQty>0?CalcOrderQty:-9999) != (ActualOrderQty>0?ActualOrderQty:-9999) &&
        (Remarks == null || Remarks == "")
      ) {
        ValidationCount++;
      }

      if (ValidationCount > 0) {
        return ValidationCount;
      }
    }
    return ValidationCount;
  };

  return (
    <>
      <OrderFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        ManyTableData={ManyTableData}
        handleDataTableChange={handleDataTableChange}
        handleRDateChange={handleRDateChange}
        selectedDate={selectedDate}
        bCompleted={bCompleted}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handlePost={handlePost}
        generatedInvoiceNo={generatedInvoiceNo}
        bFirst={bFirst}
        {...props}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default EditOrder;
